const countriesWithStates = ['US']

export default countriesWithStates
